// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__21RwZ","footer":"Form_footer__2vs1v"};